import type { TourDefinition } from '../../../models/tour.interfaces';

export const customersTour: TourDefinition = {
  module: 'customers',
  steps: [
    {
      id: 'clientes_step_1',
      order: 1,
      target: '[data-testid="btn-add-client"]',
      title: 'Registra un nuevo cliente',
      body: 'Haz clic aquí para crear un nuevo cliente en tu negocio.',
      requiredAction: 'click',
      nextStepTrigger: 'onElementClick',
      placement: 'bottom',
      skippable: true,
    },
    {
      id: 'clientes_step_2',
      order: 2,
      target: '[data-testid="client-document"]',
      title: 'Número de documento',
      body: 'Ingresa DNI, RUC, pasaporte o carnet de extranjería. Con DNI se completarán nombre y apellido automáticamente.',
      requiredAction: 'fill',
      nextStepTrigger: 'onNextButton',
      placement: 'right',
      skippable: false,
    },
    {
      id: 'clientes_step_3',
      order: 3,
      target: '[data-testid="client-name"]',
      title: 'Nombre obligatorio',
      body: 'Escribe el nombre del cliente si no se completó automáticamente.',
      requiredAction: 'fill',
      nextStepTrigger: 'onNextButton',
      placement: 'right',
      skippable: false,
    },
    {
      id: 'clientes_step_4',
      order: 4,
      target: '[data-testid="client-lastname"]',
      title: 'Apellido obligatorio',
      body: 'Escribe el apellido del cliente. Es uno de los campos obligatorios.',
      requiredAction: 'fill',
      nextStepTrigger: 'onNextButton',
      placement: 'right',
      skippable: false,
    },
    {
      id: 'clientes_step_5',
      order: 5,
      target: '[data-testid="client-birthday"]',
      title: 'Fecha de nacimiento (opcional)',
      body: 'Puedes registrar la fecha de nacimiento para personalizar promociones o recordatorios.',
      requiredAction: 'none',
      nextStepTrigger: 'onNextButton',
      placement: 'right',
      skippable: true,
    },
    {
      id: 'clientes_step_6',
      order: 6,
      target: '[data-testid="client-phone"]',
      title: 'Teléfono móvil',
      body: 'Puedes ingresar el número de contacto del cliente. No es obligatorio.',
      requiredAction: 'fill_optional',
      nextStepTrigger: 'onNextButton',
      placement: 'left',
      skippable: true,
    },
    {
      id: 'clientes_step_7',
      order: 7,
      target: '[data-testid="client-email"]',
      title: 'Correo electrónico',
      body: 'Si agregas correo electrónico podrás enviar comprobantes y recordatorios.',
      requiredAction: 'fill_optional',
      nextStepTrigger: 'onNextButton',
      placement: 'left',
      skippable: true,
    },
    {
      id: 'clientes_step_8',
      order: 8,
      target: '[data-testid="client-gender"]',
      title: 'Género del cliente',
      body: 'Selecciona el género del cliente si deseas segmentarlo.',
      requiredAction: 'select_optional',
      nextStepTrigger: 'onNextButton',
      placement: 'bottom',
      skippable: true,
    },
    {
      id: 'clientes_step_9',
      order: 9,
      target: '[data-testid="btn-save-client"]',
      title: 'Guardar cliente',
      body: 'Una vez completados nombre y apellido, el botón se activa. Haz clic para registrar al cliente.',
      requiredAction: 'click',
      nextStepTrigger: 'onElementClick',
      placement: 'bottom',
      skippable: false,
    },
    {
      id: 'clientes_step_10',
      order: 10,
      target: '[data-testid="client-list"]',
      title: 'Cliente registrado',
      body: 'Aquí verás al cliente recién registrado. Podrás usarlo para reservas o pagos.',
      requiredAction: 'none',
      nextStepTrigger: 'onFinish',
      placement: 'top',
      skippable: true,
    },
  ],
};
